import {NgModule} from '@angular/core';
import {MatSelectModule, MatSlideToggleModule} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from '../shared/shared.module';
import {ChannelChargeMgmtComponent} from './channel-charge-mgmt.component';
import {ChannelService} from './channel.service';
import {ChannelDatatableComponent} from './channel-datatable.component';
import {ChannelFormComponent} from './channel-form.component';
import {UserModule} from '../user/user.module';
import {AlertModule, BsDatepickerModule, CollapseModule, TabsModule} from 'ngx-bootstrap';
import {ThroughputModule} from '../throughput/throughput.module';
import {PictureModule} from '../picture/picture.module';
import {ChannelAddExistingComponent} from './channel-add-existing.component';
import {DatagridModule} from '../datagrid/datagrid.module';
import {ChannelDuplicateModalComponent} from './channel-duplicate-modal.component';
import {ChannelDrawingComponent} from './channel-drawing.component';
import {ChannelBulkUpdateModalService} from './channel-bulk-update-modal.service';
import {ChannelBulkUpdateModalComponent} from './channel-bulk-update-modal.component';

@NgModule({
  declarations: [
    ChannelDatatableComponent,
    ChannelFormComponent,
    ChannelAddExistingComponent,
    ChannelDuplicateModalComponent,
    ChannelDrawingComponent,
    ChannelChargeMgmtComponent,
    ChannelBulkUpdateModalComponent,
  ],
  exports: [
    ChannelDatatableComponent,
    ChannelFormComponent,
    ChannelAddExistingComponent,
    ChannelDuplicateModalComponent,
    ChannelDrawingComponent,
    ChannelChargeMgmtComponent,
    ChannelBulkUpdateModalComponent,
  ],
  imports: [
    SharedModule,
    UserModule,
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AlertModule.forRoot(),
    CollapseModule.forRoot(),
    ThroughputModule,
    PictureModule,
    BrowserAnimationsModule,
    MatSelectModule,
    DatagridModule,
    MatSlideToggleModule,
  ],
  providers: [
    ChannelService,
    ChannelBulkUpdateModalService,
  ],
  entryComponents: [
    ChannelAddExistingComponent,
    ChannelChargeMgmtComponent,
    ChannelBulkUpdateModalComponent,
  ]
})
export class ChannelModule {}





// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel.module.ts